import { useMutation } from '@tanstack/react-query';
import { orpc } from 'src/api/rpc/client';

export function useSwitchOrganization() {
  return useMutation(orpc.auth.switchOrganization.mutationOptions());
}
